import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { ScheduleDetailComponent } from '../../schedule-details/containers/schedule-detail.component';

@Component({
    selector: 'ndt-schedule-wrapper',
    styleUrls: ['./schedule-wrapper.component.scss'],
    templateUrl: './schedule-wrapper.component.html',
    standalone: false
})
export class ScheduleWrapperComponent implements AfterViewInit {
   @ViewChild(ScheduleDetailComponent) scheduleDetailComponent;
   form: UntypedFormGroup;
   constructor(private twoColumnLayoutService: TwoColumnLayoutService) {}

   get showDetailView(): boolean {
      return !!this.twoColumnLayoutService.getFirstItemId();
   }

   ngAfterViewInit(): void {
      this.form = this.scheduleDetailComponent.form;
   }
}
